import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../app/store";
import {
  RecipeQueryParams,
  TcmRecipeSummaryParams,
  getPatientRegistration,
  getTcmRecipeSummary,
  pageRecipeQuery
} from '../../../services/recipeQuery'
import { getDoctorsInDepartment } from "../../../services/user";

export const pageRecipeQueryAsync = createAsyncThunk<
  void,
  RecipeQueryParams,
  RootThunkApi<void>
>('examine/page', async (params, api) => {
  return sendAsync(pageRecipeQuery(params), api)
})

export const getPatientRegistrationAsync = createAsyncThunk<
  void,
  RecipeQueryParams,
  RootThunkApi<void>
>('getPatientRegistration/page', async (params, api) => {
  return sendAsync(getPatientRegistration(params), api)
})

//审核医师
export const getDoctorsInDepartmentAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>('getDoctorsInDepartment/page', async (params, api) => {
  return sendAsync(getDoctorsInDepartment(params), api)
})

// 中医处方汇总
export const getTcmRecipeSummaryAsync = createAsyncThunk<
  void,
  TcmRecipeSummaryParams,
  RootThunkApi<void>
>('tcmRecipeSummary/get', async (params, api) => {
  return sendAsync(getTcmRecipeSummary(params), api)
})